export const WORKLOG_OVERLAP_PROBLEM_TYPE = "/problems/worklog-overlap";

/**
 * The 409 response when a worklog to be saved overlaps another worklog of the employee on the same day.
 */
export interface WorklogOverlapProblem {
  type: typeof WORKLOG_OVERLAP_PROBLEM_TYPE;
  title: string;
  status: 409;
  detail: string;
  instance: string;
  overlappingWorklog: {
    id: string;
    date: string;
    /** HH:mm */
    start: string;
    /** HH:mm */
    end: string;
    order: {
      id: string;
      name: string;
    };
  };
}
